/** Wraps a record number or code in a left-to-right isolate, so it reads the same inside an Arabic sentence. */
export const isolate = (value: string) => `\u2066${value}\u2069`;
